import {
  ComprasEstado,
  ComprasEstadoLabels,
} from 'src/utils/enums/ComprasEstado';
import { ComprasFormState } from './types';
import { colorMapping } from 'src/utils/enums/ComprasEstado';

import {
  marcarPagadaComprasF,
  marcarRecepcionadaComprasF,
  solicitarCotizacionComprasF,
  realizarPedidoComprasF,
} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ComprasFormState = {
  data: null,
  status: null,
  actions: null,
  insumos: null,
  summary: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'comprasForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
      state.insumos = null;
    },

    setFormStatusBorrador(state) {
      state.status = {
        id: ComprasEstado.Borrador,
        text: ComprasEstado[ComprasEstado.Borrador].toUpperCase(),
        color: colorMapping[ComprasEstado.Borrador],
      };
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: false },
        validez: { readOnly: false },
        condiciones: { readOnly: false },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: false },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: true, visible: false },
        fechaPedidoEnviado: { readOnly: true, visible: false },
        fechaPedidoRecibido: { readOnly: true, visible: false },
        proveedorId: { readOnly: false },
      };
      state.actions = {
        agregarInsumos: {
          disabled: false,
          tooltip: 'Agregar insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
        modificar: {
          visible: false,
          disabled: true,
          tooltip: 'Modificar',
        },
        marcarPagadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como pagada',
        },
        marcarRecepcionadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como recepcionada',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar con cotización recibida',
        },
        solicitarCotizacionComprasF: {
          visible: true,
          text: 'Cotización',
          disabled: false,
          tooltip: 'Solicitar la cotización para la compra',
        },
        realizarPedidoComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Realizar el pedido para la compra',
        },
      };
    },
    setFormStatusCotizacionSolicitada(state) {
      state.status = {
        id: ComprasEstado.CotizacionSolicitada,
        text: ComprasEstadoLabels[
          ComprasEstado.CotizacionSolicitada
        ].toUpperCase(),
        color: colorMapping[ComprasEstado.CotizacionSolicitada],
      };
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: true },
        validez: { readOnly: true },
        condiciones: { readOnly: true },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: true },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: true },
        fechaPedidoEnviado: { readOnly: true },
        fechaPedidoRecibido: { readOnly: true },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        agregarInsumos: {
          disabled: true,
          tooltip: 'Agregar insumos',
        },
        guardar: {
          visible: false,
          disabled: true,
          tooltip: 'Guardar',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la cotización recibida para esta compra.',
        },
        marcarPagadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como pagada',
        },
        modificar: {
          visible: true,
          disabled: false,
          tooltip: 'Modificar',
        },
        marcarRecepcionadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como recepcionada',
        },
        solicitarCotizacionComprasF: {
          visible: true,
          disabled: false,
          text: 'Re-solicitar Cotización',
          tooltip: 'Enviar otra solicitud de cotización para la compra',
        },
        realizarPedidoComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Realizar el pedido para la compra',
        },
      };

      state.insumos = { readOnly: true };
    },
    setFormStatusCotizacionRecibida(state) {
      state.status = {
        id: ComprasEstado.CotizacionRecibida,
        text: ComprasEstadoLabels[
          ComprasEstado.CotizacionRecibida
        ].toUpperCase(),
        color: colorMapping[ComprasEstado.CotizacionRecibida],
      };
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: true },
        validez: { readOnly: true },
        condiciones: { readOnly: true },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: true },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: true },
        fechaPedidoEnviado: { readOnly: true },
        fechaPedidoRecibido: { readOnly: true },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        agregarInsumos: {
          disabled: true,
          tooltip: 'Agregar insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar con cotización recibida',
        },
        marcarPagadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como pagada',
        },

        modificar: {
          visible: true,
          disabled: false,
          tooltip: 'Modificar',
        },
        marcarRecepcionadaComprasF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la compra como recepcionada',
        },
        solicitarCotizacionComprasF: {
          visible: false,
          disabled: false,
          text: 'Cotización',
          tooltip: 'Solicitar la cotización para la compra',
        },
        realizarPedidoComprasF: {
          visible: true,
          disabled: false,
          tooltip: 'Realizar el pedido para la compra',
        },
      };

      state.insumos = {
        readOnly: false,
        visibleLoteAndVencimiento: true,
      };
    },
    setFormStatusPedidoRealizado(state) {
      state.status = {
        id: ComprasEstado.PedidoRealizado,
        text: ComprasEstadoLabels[ComprasEstado.PedidoRealizado].toUpperCase(),
        color: colorMapping[ComprasEstado.PedidoRealizado],
      };
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: true },
        validez: { readOnly: true },
        condiciones: { readOnly: true },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: true },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: true },
        fechaPedidoEnviado: { readOnly: true },
        fechaPedidoRecibido: { readOnly: true },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        agregarInsumos: {
          disabled: true,
          tooltip: 'Agregar insumos',
        },

        modificar: {
          visible: true,
          disabled: false,
          tooltip: 'Modificar',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar con cotización recibida',
        },
        guardar: {
          visible: false,
          disabled: true,
          tooltip: 'Guardar',
        },

        marcarPagadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como pagada',
        },
        marcarRecepcionadaComprasF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la compra como recepcionada',
        },
        solicitarCotizacionComprasF: {
          visible: false,
          disabled: false,
          text: 'Cotización',
          tooltip: 'Solicitar la cotización para la compra',
        },
        realizarPedidoComprasF: {
          visible: false,
          disabled: false,
          tooltip: 'Realizar el pedido para la compra',
        },
      };

      state.insumos = {
        readOnly: false,
        visibleLoteAndVencimiento: true,
      };
    },
    setFormStatusPedidoRecepcionado(state) {
      state.status = {
        id: ComprasEstado.PedidoRecepcionado,
        text: ComprasEstadoLabels[
          ComprasEstado.PedidoRecepcionado
        ].toUpperCase(),
        color: colorMapping[ComprasEstado.PedidoRecepcionado],
      };
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: true },
        validez: { readOnly: true },
        condiciones: { readOnly: true },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: true },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: true },
        fechaPedidoEnviado: { readOnly: true },
        fechaPedidoRecibido: { readOnly: true },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        agregarInsumos: {
          disabled: true,
          tooltip: 'Agregar insumos',
        },
        guardar: {
          visible: false,
          disabled: true,
          tooltip: 'Guardar',
        },
        modificar: {
          visible: true,
          disabled: false,
          tooltip: 'Modificar',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar con cotización recibida',
        },
        marcarPagadaComprasF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la compra como pagada',
        },
        marcarRecepcionadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como recepcionada',
        },
        solicitarCotizacionComprasF: {
          visible: false,
          disabled: false,
          text: 'Cotización',
          tooltip: 'Solicitar la cotización para la compra',
        },
        realizarPedidoComprasF: {
          visible: false,
          disabled: false,
          tooltip: 'Realizar el pedido para la compra',
        },
      };

      state.insumos = { readOnly: true, visibleLoteAndVencimiento: true };
    },
    setFormStatusPedidoRecepcionadoParcial(state) {
      state.status = {
        id: ComprasEstado.PedidoRecepcionadoParcial,
        text: ComprasEstadoLabels[
          ComprasEstado.PedidoRecepcionadoParcial
        ].toUpperCase(),
        color: colorMapping[ComprasEstado.PedidoRecepcionadoParcial],
      };
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: true },
        validez: { readOnly: true },
        condiciones: { readOnly: true },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: true },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: true },
        fechaPedidoEnviado: { readOnly: true },
        fechaPedidoRecibido: { readOnly: true },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        agregarInsumos: {
          disabled: true,
          tooltip: 'Agregar insumos',
        },
        guardar: {
          visible: false,
          disabled: true,
          tooltip: 'Guardar',
        },
        modificar: {
          visible: true,
          disabled: false,
          tooltip: 'Modificar',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar con cotización recibida',
        },
        marcarPagadaComprasF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la compra como pagada',
        },
        marcarRecepcionadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como recepcionada',
        },
        solicitarCotizacionComprasF: {
          visible: false,
          disabled: false,
          text: 'Cotización',
          tooltip: 'Solicitar la cotización para la compra',
        },
        realizarPedidoComprasF: {
          visible: false,
          disabled: false,
          tooltip: 'Realizar el pedido para la compra',
        },
      };

      state.insumos = { readOnly: true, visibleLoteAndVencimiento: true };
    },
    setFormStatusPagado(state) {
      state.status = {
        id: ComprasEstado.Pagado,
        text: ComprasEstadoLabels[ComprasEstado.Pagado].toUpperCase(),
        color: colorMapping[ComprasEstado.Pagado],
      };
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: true },
        validez: { readOnly: true },
        condiciones: { readOnly: true },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: true },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: true },
        fechaPedidoEnviado: { readOnly: true },
        fechaPedidoRecibido: { readOnly: true },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        agregarInsumos: {
          disabled: true,
          tooltip: 'Agregar insumos',
        },
        modificar: {
          visible: true,
          disabled: false,
          tooltip: 'Modificar',
        },
        guardar: {
          visible: false,
          disabled: true,
          tooltip: 'Guardar',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar con cotización recibida',
        },
        marcarPagadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como pagada',
        },
        marcarRecepcionadaComprasF: {
          visible: false,
          disabled: false,
          tooltip: 'Marcar la compra como recepcionada',
        },
        solicitarCotizacionComprasF: {
          visible: false,
          disabled: false,
          text: 'Cotización',
          tooltip: 'Solicitar la cotización para la compra',
        },
        realizarPedidoComprasF: {
          visible: false,
          disabled: false,
          tooltip: 'Realizar el pedido para la compra',
        },
      };

      state.insumos = { readOnly: true, visibleLoteAndVencimiento: true };
    },
    setModifyingInsumos(state) {
      // Guardar estado anterior.
      state.previousState = {
        status: state.status,
        actions: state.actions,
      };

      state.actions = {
        agregarInsumos: {
          disabled: true,
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
        },
        modificar: {
          visible: state.actions!.modificar.visible,
          disabled: true,
          tooltip: 'Modificar',
        },
        guardar: {
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
          disabled: true,
          visible: true,
        },
        marcarCotizacionRecibidaComprasF: {
          visible: state.actions!.marcarCotizacionRecibidaComprasF.visible,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        marcarPagadaComprasF: {
          visible: state.actions!.marcarPagadaComprasF.visible,
          disabled: true,
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
        },
        marcarRecepcionadaComprasF: {
          visible: state.actions!.marcarRecepcionadaComprasF.visible,
          disabled: true,
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
        },
        solicitarCotizacionComprasF: {
          visible: state.actions!.solicitarCotizacionComprasF.visible,
          disabled: true,
          text: 'Cotización',
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        realizarPedidoComprasF: {
          visible: state.actions!.realizarPedidoComprasF.visible,
          disabled: true,
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
        },
      };
    },
    //Se ejecuta cuando llegamos al formulario compras desde el action comprar en insumo.
    setInsertInsumoFromAction(state) {
      // Guardar estado anterior.
      state.previousState = {
        status: {
          id: ComprasEstado.Borrador,
          text: ComprasEstado[ComprasEstado.Borrador].toUpperCase(),
          color: colorMapping[ComprasEstado.Borrador],
        },
        actions: {
          agregarInsumos: {
            disabled: false,
            tooltip: 'Agregar insumos',
          },
          guardar: {
            visible: true,
            disabled: false,
            tooltip: 'Guardar',
          },

          marcarPagadaComprasF: {
            visible: true,
            disabled: true,
            tooltip: 'Marcar la compra como pagada',
          },
          marcarRecepcionadaComprasF: {
            visible: true,
            disabled: true,
            tooltip: 'Marcar la compra como recepcionada',
          },
          solicitarCotizacionComprasF: {
            visible: true,
            disabled: false,
            text: 'Cotización',
            tooltip: 'Solicitar la cotización para la compra',
          },
          realizarPedidoComprasF: {
            visible: false,
            disabled: true,
            tooltip: 'Realizar el pedido para la compra',
          },
        },
        data: {
          id: { readOnly: true },
          plazoDeEntrega: { readOnly: false },
          validez: { readOnly: false },
          condiciones: { readOnly: false },
          descuento: { readOnly: false },
          totalUsd: { readOnly: true },
          totalArs: { readOnly: true },
          pesoTotal: { readOnly: true },
          cantidadTotal: { readOnly: true },
          monedaArsUsd: { readOnly: true },
          totalDescuentoUsd: { readOnly: true },
          totalDescuentoArs: { readOnly: true },
          notas: { readOnly: false },
          estado: { readOnly: true },
          fechaCotizacionSolicitada: { readOnly: true },
          fechaPedidoEnviado: { readOnly: true },
          fechaPedidoRecibido: { readOnly: true },
          proveedorId: { readOnly: false },
        },
      };
      state.status = {
        id: ComprasEstado.Borrador,
        text: ComprasEstado[ComprasEstado.Borrador].toUpperCase(),
        color: colorMapping[ComprasEstado.Borrador],
      };
      state.actions = {
        agregarInsumos: {
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar con cotización recibida',
        },
        guardar: {
          tooltip: 'Por favor, termine de modificar productos para guardar.',
          disabled: true,
          visible: true,
        },
        modificar: {
          visible: false,
          disabled: true,
          tooltip: 'Modificar',
        },
        marcarPagadaComprasF: {
          visible: true,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        marcarRecepcionadaComprasF: {
          visible: true,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        solicitarCotizacionComprasF: {
          visible: true,
          disabled: true,
          text: 'Cotización',
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        realizarPedidoComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
      };
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: false },
        validez: { readOnly: false },
        condiciones: { readOnly: false },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: false },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: true },
        fechaPedidoEnviado: { readOnly: true },
        fechaPedidoRecibido: { readOnly: true },
        proveedorId: { readOnly: true },
      };
    },
    setModifyingInsumosFinished(state) {
      // Restaurar estado anterior
      state.status = state.previousState!.status;
      state.data = state.previousState!.data;
      state.actions = state.previousState!.actions;
      state.previousState = null;
    },
    setModifying(state) {
      state.data = {
        id: { readOnly: true },
        plazoDeEntrega: { readOnly: false },
        validez: { readOnly: false },
        condiciones: { readOnly: false },
        descuento: { readOnly: true },
        totalUsd: { readOnly: true },
        totalArs: { readOnly: true },
        cantidadTotal: { readOnly: true },
        monedaArsUsd: { readOnly: true },
        totalDescuentoUsd: { readOnly: true },
        totalDescuentoArs: { readOnly: true },
        notas: { readOnly: false },
        estado: { readOnly: true },
        fechaCotizacionSolicitada: { readOnly: false },
        fechaPedidoEnviado: { readOnly: false },
        fechaPedidoRecibido: { readOnly: false },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        agregarInsumos: {
          disabled: false,
          tooltip: 'Agregar insumos',
        },
        modificar: {
          visible: false,
          disabled: true,
          tooltip: 'Modificar',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
        marcarCotizacionRecibidaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar con cotización recibida',
        },
        marcarPagadaComprasF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la compra como pagada',
        },
        marcarRecepcionadaComprasF: {
          visible: false,
          disabled: false,
          tooltip: 'Marcar la compra como recepcionada',
        },
        solicitarCotizacionComprasF: {
          visible: false,
          disabled: false,
          text: 'Cotización',
          tooltip: 'Solicitar la cotización para la compra',
        },
        realizarPedidoComprasF: {
          visible: false,
          disabled: false,
          tooltip: 'Realizar el pedido para la compra',
        },
      };

      // Listas
      state.insumos = {
        readOnly: false,
        visibleLoteAndVencimiento: state.insumos?.visibleLoteAndVencimiento,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(marcarPagadaComprasF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarPagadaComprasF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarRecepcionadaComprasF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarRecepcionadaComprasF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(solicitarCotizacionComprasF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(solicitarCotizacionComprasF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(realizarPedidoComprasF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(realizarPedidoComprasF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) => state.compras.form.status;

export const selectMarcarPagadaComprasF = (state: RootState) =>
  state.compras.form.actions?.marcarPagadaComprasF;

export const selectMarcarRecepcionadaComprasF = (state: RootState) =>
  state.compras.form.actions?.marcarRecepcionadaComprasF;

export const selectSolicitarCotizacionComprasF = (state: RootState) =>
  state.compras.form.actions?.solicitarCotizacionComprasF;

export const selectRealizarPedidoComprasF = (state: RootState) =>
  state.compras.form.actions?.realizarPedidoComprasF;

export const selectGuardar = (state: RootState) =>
  state.compras.form.actions?.guardar;

export const selectAgregarInsumos = (state: RootState) =>
  state.compras.form.actions?.agregarInsumos;

export const selectMarcarCotizacionRecibidaComprasF = (state: RootState) =>
  state.compras.form.actions?.marcarCotizacionRecibidaComprasF;

export const selectModificar = (state: RootState) =>
  state.compras.form.actions?.modificar;

// Export actions
export const {
  resetForm,
  setModifying,
  setFormStatusBorrador,
  setFormStatusCotizacionSolicitada,
  setFormStatusCotizacionRecibida,
  setFormStatusPedidoRealizado,
  setFormStatusPedidoRecepcionado,
  setFormStatusPedidoRecepcionadoParcial,
  setFormStatusPagado,
  setModifyingInsumos,
  setModifyingInsumosFinished,
  setInsertInsumoFromAction,
} = formSlice.actions;

export default formSlice.reducer;
